import { pubText } from "../../i18n/publicTranslation";
import React from 'react';
import type { UsageSource } from '../../api/usage';
import FableButterflyIcon from './FableButterflyIcon';
import PillMenu from './PillMenu';

export default function UsageProductSelect({ value, onChange, label = 'Story experience' }: {
  value: UsageSource; onChange: (value: UsageSource) => void; label?: string;
}) {
  return (
    <PillMenu label={pubText(label)} value={value} onChange={onChange} mobileSheet plainIcons options={[
      { value: 'classic', label: 'Go', icon: <FableButterflyIcon width={22} height={22} color="#D8A363" /> },
      { value: 'gambit', label: 'Gambit', icon: <FableButterflyIcon width={22} height={22} /> },
    ]} />
  );
}
